import React, { useContext } from 'react';
import { Text, TextVariant } from '@naf/text';
import { formatDate } from '@utils/Dates';
import { DowngradeContext } from '@pages/downgrade/context/DowngradeContext';
import * as S from './TextWithEndDate.styles';

interface TextWithEndDateProps {
  value: {
    text: string;
  };
}

export const TextWithEndDate = ({ value: { text } }: TextWithEndDateProps) => {
  const { endDate } = useContext(DowngradeContext);

  if (!endDate) return null;

  return (
    <Text variant={TextVariant.ArticleText}>
      {text}{' '}
      <S.BoldText tag="span" variant={TextVariant.ArticleText}>
        {formatDate(endDate)}
      </S.BoldText>
    </Text>
  );
};

export const TextWithEndDateSerializer =
  () =>
  ({ value }: TextWithEndDateProps) => <TextWithEndDate value={value} />;

export { BoldText } from './TextWithEndDate.styles';
